<div *ngIf="errorService.isErrorVisible" class="fixed top-0 left-0 right-0 z-50 p-4">
  <div class="max-w-4xl mx-auto">
    <div class="
      bg-red-50 
      border 
      border-red-200 
      rounded-lg 
      p-4 
      shadow-lg
      flex 
      items-center 
      justify-between
    ">
      <div class="flex items-center">
        <svg class="w-6 h-6 text-red-500 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z"></path>
        </svg>
        <div>
          <h3 class="text-sm font-medium text-red-800">Error</h3>
          <p class="text-sm text-red-700 mt-1">
            {{ errorService.errorMessage }}
          </p>
        </div>
      </div>
      <div class="flex items-center space-x-2">
        <button
          (click)="errorService.closeErrorPopup()"
          class="
            inline-flex 
            items-center 
            p-1.5 
            text-red-400 
            hover:text-red-600 
            transition-colors 
            duration-200
          "
          aria-label="Close"
        >
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
          </svg>
        </button>
      </div>
    </div>
  </div>
</div>
